import SliderModal from './SliderModal';
export default SliderModal;
